<template>
  <div class="header">
      <a v-if="this.logged_role!='ceo' && this.logged_role!='company' && this.logged_role!='' && this.logged_role!='sadmin'" href="/JK" class="title_link">
        <img src="../../assets/menu_logo.png" style="height:40px;padding-top:13px;margin-left:20px;" />
        <span style="position:relative;bottom:10px;left:5px;">组织健康度诊断系统</span>
      </a>
      <!-- 企业用户取消首页链接 -->
      <a v-else class="title_link" style="text-decoration:none;">
        <img src="../../assets/menu_logo.png" style="height:40px;padding-top:13px;margin-left:20px;" />
        <span style="position:relative;bottom:10px;left:5px;">组织健康度诊断系统</span>
      </a>
      <div class="log_main">
          <div>
            <div v-if="this.logged_role=='admin'">
                <el-menu :default-active="activeIndex" :router="is_router" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
                active-text-color="#FFD04B">
                    <el-menu-item index="/JK/tasks" class="single_menu">任务管理</el-menu-item>
                    <el-menu-item index="/JK/autotest" class="single_menu">批量测试</el-menu-item>
                </el-menu>
            </div>
            <div v-else-if="this.logged_role=='company'||this.logged_role=='sadmin'">
                <el-menu :default-active="activeIndex" :router="is_router" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
                active-text-color="#FFD04B">
                </el-menu>
            </div>
            <div v-else-if="this.logged_role=='ceo'">
                <el-menu :default-active="activeIndex" :router="is_router" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
                active-text-color="#FFD04B">
                    <el-menu-item index="/JK/dataCenter" class="single_menu">数据中心</el-menu-item>
                </el-menu>
            </div>
            <div v-else>
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
                active-text-color="#FFD04B" @select="menu_select">
                    <el-menu-item index="/JK/myass" class="single_menu">我的评估
                        <!-- 这里改用select方法进行路由跳转，原因是无法获取task_id和login_random_series变量，路由由/JK跳转到/JK/myass后变量就丢失了 -->
                        <!-- <router-link :to="{path:'/JK/myass', query:{task:this.task_id, id:this.login_random_series}}">我的评估</router-link> -->
                    </el-menu-item>
                    <el-menu-item index="/JK/dataCenter" class="single_menu">数据中心
                        <!-- <router-link :to="{path:'/JK/dataCenter', query:{task:this.task_id, id:this.login_random_series}}">数据中心</router-link> -->
                    </el-menu-item>
                </el-menu>
            </div>
            <!-- <el-menu :default-active="activeIndex" :router="is_router" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
            active-text-color="#FFD04B"> -->
                <!-- 这里过滤要用v-show，用v-if会导致刷新页面时activeIndex指向当前路由无效！ -->
                <!-- <el-menu-item index="1" class="single_menu" v-show="this.logged_role==''">我的评估</el-menu-item> -->
                <!-- <el-menu-item index="/JK/myass" class="single_menu" v-show="this.logged_role!='ceo' && this.logged_role!='company' && this.logged_role!=''">我的评估</el-menu-item>
                <el-menu-item index="/JK/tasks" class="single_menu" v-show="this.logged_role=='admin'">任务管理</el-menu-item>
                <el-menu-item index="/JK/dataCenter" class="single_menu" v-show="this.logged_role!='admin' && this.logged_role!='company' && this.logged_role!=''">数据中心</el-menu-item> -->
            <!-- </el-menu> -->
            <!-- <el-menu :default-active="activeIndex" :router="false" class="el-menu-demo" mode="horizontal" background-color="#545C64" text-color="#FFFFFF" 
            active-text-color="#FFD04B" v-else>
                <el-menu-item index="1" class="single_menu">我的任务</el-menu-item>
            </el-menu>  -->
          </div> 
      <div class="log_left"><span>你好，{{ logged_user }}</span></div>
      <div class="log_right" v-if="logged_role!=''"><el-dropdown placement="top-start" @command="handleCommand">
          <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
             <!-- <el-dropdown-item icon="el-icon-edit" command="chg_passwd" v-if="this.logged_role=='admin'">修改密码</el-dropdown-item> -->
             <el-dropdown-item icon="el-icon-edit" command="chg_passwd">修改密码</el-dropdown-item>
             <el-dropdown-item icon="el-icon-user" command="logout">注销</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
      <!-- 注意！ el-dialog要放到el-dropdown外面，否则引用会报错-->
      <el-dialog :title="chg_passwd_title" :visible.sync="dialogFormVisible" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="当前密码" prop="old_passwd">
                <el-input v-model="form.old_passwd" type="password" placeholder="请输入当前密码" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="new_passwd">
                <el-input v-model="form.new_passwd" type="password" placeholder="请输入新密码" show-password></el-input>
            </el-form-item>
            <div style="text-align:center;line-height:40px;">
                <el-button @click="cancle_chg">取 消</el-button>
                <el-button type="primary" @click="submit_chg">确 定</el-button>
            </div>
        </el-form>
      </el-dialog>
      </div></div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
// import chgPasswd from "./ChgPasswd.vue";
export default {
    beforeCreate(){
        // 后期改造步骤：判断本地的usertoken，为空则跳转登录界面，不为空则使用该usertoken向后台进行验证是否存在和合法，不存在或不合法
        // 也跳转到登录界面。通过验证后则返回logged_role信息，用于过滤菜单。
        // if (localStorage.getItem("username") != null) {
        //     this.logged_user = '你好，' + localStorage.getItem("username");
        //     if(localStorage.getItem("username")=='admin'){
        //         this.logged_role = 'admin';
        //     }else{
        //         this.logged_role = 'common';
        //     }
        // }else{
        //     this.$router.push({
        //         path: '/my_takepartin',
        //     }) 
        // }
        // 下面的操作是为了刷新页面时，按照当前地址刷新到对应的路由，防止URL和实际的路由不对应，且默认导航指定为当前路由
        // this.$router.push({
        //     path: this.$route.path,
        // })
        // console.log("active path: " + this.$route.path);
        // 如果path中有有效的id，则判断id是否有效，否则正常校验用户token
        this.login_random_series = this.$route.query.id;
        this.task_id = this.$route.query.task;
        localStorage.setItem('login_series', this.login_random_series);
        localStorage.setItem('task_id', this.task_id);
        let params;
            params = {
                login_random_series: this.login_random_series,
                task_id: this.task_id,
            }
        if((typeof(this.login_random_series) != "undefined") && (this.login_random_series != '')){
            getdata.getListP("checkLoginRandomSeries", params)
                .then((resp) => {
                    if(resp.data.code != 200){
                        this.$router.push({
                            path: '/JKlogin',
                        });
                    }else{
                        this.logged_user = resp.data.data;
                        this.activeIndex = this.$route.path;
                        // this.activeIndex = "1";
                        // if(this.$route.path == "/JK/myass") {
                        //     this.activeIndex = "1";
                        // }else if(this.$route.path == "/JK/dataCenter") {
                        //     this.activeIndex = "2";
                        // }
                    }
                })
                .catch(() => {
                    this.$router.push({
                        path: '/JKlogin',
                    });
                })
            
            // this.is_router = false;
        }else{
            // 从后台获取用户类型，以便按照用户类型展示对应的菜单项
            getdata.getList("checklogin")
                .then(resp => {
                        this.is_router = true;
                        this.logged_role = resp.data.usertype;
                        this.logged_user = resp.data.username;
                        this.task_id = resp.data.task_id;
                        // this.activeIndex = this.$route.path;
                        if(this.$route.path=='/JK'){
                            if(this.logged_role=='ceo'){
                                this.$router.push({
                                    path: '/JK/dataCenter',
                                });
                                // console.log("logged_role: " + this.logged_role);
                                this.activeIndex = '/JK/dataCenter';
                            }else if(this.logged_role=='admin'){
                                this.$router.push({
                                    path: '/JK/tasks',
                                });
                                // console.log("logged_role: " + this.logged_role);
                                this.activeIndex = '/JK/tasks';
                            }
                        }
                        // 增加对带参数的路由的判断
                        if(this.$route.path.includes('/JK/taskmgmt')) {
                            this.activeIndex = '/JK/tasks';
                        }
                        // this.activeIndex = this.$route.path;
                        // console.log("activeIndex: " + this.activeIndex);
                })
                .catch(() => {
                    // token失效跳转至登录界面，无token说明是链接直接登录，则跳转至404页面
                    // if(localStorage.getItem("token") == null){
                    //     this.$router.push({
                    //         path: '/404',
                    //     });
                    // }else{
                    this.$router.push({
                        path: '/JKlogin',
                    });
                    // }
                })
            
            
            // console.log("old activeIndex: " + this.activeIndex);
            // 根据当前的路由信息，标识对应的菜单项（主要为了防止刷新页面后不显示当前选中的菜单项） 
            // this.activeIndex = this.$route.path;
            // console.log("activeIndex: " + this.activeIndex);
            // 增加对带参数的路由的判断
            // if(this.$route.path.includes('/JK/taskmgmt')) {
            //     this.activeIndex = '/JK/tasks';
            // }
            // console.log("created activeIndex: " + this.activeIndex);
        } 
        
        // console.log("active index: " + this.activeIndex);
        // 检查用户是否已修改密码，未修改则弹出修改密码窗口----组织健康度调研不涉及
        // getdata.getList("checkPassMod")
        //     .then(resp => {
        //         if(resp.data.code != 200){
        //         this.chg_passwd_title = '首次登录或重置密码后，请修改密码，谢谢！';
        //         this.dialogFormVisible = true;
        //         this.$message({
        //             message: resp.data.message,
        //             type: 'warning',
        //             duration: 4000,
        //         })
        //         }
        //     })
        //     .catch(() => {

        //     })
    },
    created() {
        this.activeIndex = this.$route.path;
        // if(this.$route.path.includes('/JK/myass?task')) {
        //     this.activeIndex = '1';
        // }else if(this.$route.path.includes('/JK/dataCenter?task')) {
        //     this.activeIndex = '2';
        // }
    },
    // updated() {
        
    // },
    data() {
        return {
            logged_user: '',
            logged_role: '',
            chengshu_name: '管理成熟度测评',
            jiankang_name: '组织健康度测评',
            activeIndex: '',
            dialogFormVisible: false,
            chg_passwd_title: '修改密码',
            form: {
              old_passwd: '',
              new_passwd: '',
            },
            is_router: true,
            task_id: null,
            login_random_series: null,
        }
    },
    // watch: {
    // //   监听路由状态并用ref直接改变activeIndex
    //     $route(route) {
    //         let paths = this.$route.path;
    //         this.activeIndex = paths;
    //         console.log(route);
    //     },
    // },
    methods: {
        menu_select(index, index_path) {
            // this.task_id = localStorage.getItem('task_id');
            // this.login_random_series = localStorage.getItem('login_series');
            this.login_random_series = this.$route.query.id;
            this.task_id = this.$route.query.task;
            if(index=="/JK/myass"){
                this.$router.push({
                    path: '/JK/myass',
                    query: {task:this.task_id, id:this.login_random_series}
                });
            }else if(index=="/JK/dataCenter"){
                this.$router.push({
                    path: '/JK/dataCenter',
                    query: {task:this.task_id, id:this.login_random_series}
                });
            }
            console.log(index, index_path);
        },
        cancle_chg() {
            this.dialogFormVisible = false;
            // 增加处理：初始登录未修改密码直接取消修改密码时，则退回到登录页面
            getdata.getList("checkPassMod")
              .then(resp => {
                  if(resp.data.code != 200){
                    this.$router.push({
                        path: '/JKlogin',
                    });
                  }
              })
              .catch(() => {

              })           
        },
        submit_chg() {
            postdata.postList("chgPasswd", JSON.stringify(this.form))
              .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                        duration: 2500,
                    })
                    this.chg_passwd_title = '修改密码';
                    this.dialogFormVisible = false;
                    // 修改密码后，强制退出并要求重新登录
                    this.$router.push({
                        path: '/JKlogin',
                    });
                }else{
                    this.form.old_passwd = '';
                    this.form.new_passwd = '';
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 2000,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        handleCommand(command) {
            switch(command){
                case 'chg_passwd':
                    this.dialogFormVisible = true;
                    break;
                case 'logout':
                    getdata.getList("logout")
                        .then(resp => {
                            if(resp.data.code == 200){
                                this.$message({
                                    message: '已登出！',
                                    type: 'success',
                                })
                                localStorage.removeItem('username');
                                localStorage.removeItem('token');
                                this.$router.push({
                                    path: '/JKlogin',
                                })  
                            }
                        })
                        .catch(() => {
                            this.$message({
                                message: '操作失败！',
                                type: 'error',
                            })
                        })
                    break;
                default:
                    break;
            }
        },
    }
}
</script>


<style scoped>
.header {
    position: absolute;
    line-height: 70px;
    background-color: #545C64;
    left: 0px;
    right: 0px;
    top: 0px;
    color: white;
    text-align: left;
    padding-top: 2px;
    /* min-width: 1430px; */
    min-width: 1080px;
}
.title_link {
    text-decoration: unset;
    font-size: 27px;
    color: white;
    display: block;
    height: 70px;
    line-height: 70px;
    width: 340px;
}
.title {
    color: #fff;
    padding-left: 5px;
    font-size: 25px;
}
.log_main {
    position: absolute;
    top: 0px;
    left: 400px;
    /* float: right; */
    right: 0px;
}
.el-menu {
    border-bottom: none;
}
.single_menu {
    width: 140px;
    padding-left: 30px;
}
.single_menu a {
    text-decoration: none;
}
.el-menu-item {
    font-size: 20px;
    line-height: 70px;
    height: 67px;
}
.el-submenu /deep/ .el-submenu__title {
    font-size: 20px;
    line-height: 70px;
    height: 67px;
}
/* .sub_menu /deep/ .el-submenu__title {
    line-height: 36px;
    height: 36px;
} */
.log_left {
    /* float: left;
    margin-left: 2%;
    margin-right: 10px; */
    position: absolute;
    top: 0;
    right: 100px;
}
.log_left span {
    /* cursor: pointer; */
    color: white;
    font-size: 15px;
}
/* .log_left span:hover {
    color: rgb(255, 208, 75);
} */
.log_right {
    /* float: left; */
    position: absolute;
    top: 0;
    right: 20px;
}
/* .unlogin {
    cursor: pointer;
    float: right;
    margin-right: 50px;
    font-size: 16px;
    color: #fff;
} */

/* .unlogin:hover {
    text-decoration: underline;
} */
.el-dropdown-link {
    cursor: pointer;
    color: #fff;
}
.el-icon-arrow-down {
    font-size: 16px;
}
.el-dropdown {
    float: right;
    margin-right: 50px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
::v-deep .el-dialog__header {
    line-height: 0px;
}
::v-deep .el-dropdown-menu__item {
    width: 80px;
}
</style>